import styled from 'styled-components';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

export const Page = styled.main`
  min-height: 100vh;
  background:
    radial-gradient(circle at 80% 0%, ${(props) => props.theme.text}1e 0%, transparent 45%),
    #050505;
  color: #fff;
  padding: 0 0 90px;
`;

export const Wrap = styled.div`
  max-width: 980px;
  margin: 0 auto;
  padding: 56px 50px 0;

  @media screen and (max-width: 768px) {
    padding: 40px 22px 0;
  }
`;

export const Back = styled(Link)`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 600;
  color: #aab2c0;
  text-decoration: none;
  margin-bottom: 34px;
  transition: color 0.2s ease, gap 0.2s ease;

  &:hover {
    color: ${(props) => props.theme.text};
    gap: 12px;
  }
`;

export const Meta = styled(motion.div)`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
`;

export const Pill = styled.span`
  font-size: 12px;
  font-weight: 700;
  padding: 6px 13px;
  border-radius: 999px;
  color: ${(props) => props.theme.text};
  background: ${(props) => props.theme.text}1c;
  border: 1px solid ${(props) => props.theme.text}3a;
`;

export const MetaText = styled.span`
  font-size: 14px;
  color: #8b94a3;
`;

export const Title = styled(motion.h1)`
  font-size: 52px;
  font-weight: 800;
  line-height: 1.1;
  margin-bottom: 14px;
  font-family: 'Poppins', sans-serif;

  @media screen and (max-width: 768px) {
    font-size: 36px;
  }
`;

export const Lead = styled(motion.p)`
  font-size: 19px;
  line-height: 1.6;
  color: #c4ccd8;
  margin-bottom: 36px;
  max-width: 720px;

  @media screen and (max-width: 768px) {
    font-size: 17px;
  }
`;

export const Hero = styled(motion.div)`
  border-radius: 22px;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.1);
  margin-bottom: 44px;
  box-shadow: 0 40px 90px -40px ${(props) => props.theme.text}aa;

  img {
    width: 100%;
    display: block;
  }
`;

/* ---- Gallery ---- */
export const Gallery = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
  margin-bottom: 44px;
`;

export const GalleryRow = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 14px;

  @media screen and (max-width: 640px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;

export const GalleryItem = styled(motion.button)`
  position: relative;
  padding: 0;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 16px;
  overflow: hidden;
  cursor: pointer;
  background: #0d0d10;
  height: ${({ $hero }) => ($hero ? 'clamp(280px, 42vw, 520px)' : '200px')};
  transition: border-color 0.2s ease, transform 0.2s ease;

  &:hover {
    border-color: ${(props) => props.theme.text};
    transform: translateY(-3px);
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }

  @media screen and (max-width: 640px) {
    height: ${({ $hero }) => ($hero ? '220px' : '150px')};
  }
`;

export const Lightbox = styled(motion.div)`
  position: fixed;
  inset: 0;
  z-index: 1000;
  background: rgba(2, 2, 4, 0.94);
  backdrop-filter: blur(10px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px;

  @media screen and (max-width: 768px) {
    padding: 16px;
  }
`;

export const LBImg = styled(motion.img)`
  max-width: 90vw;
  max-height: 86vh;
  border-radius: 12px;
  box-shadow: 0 30px 90px -30px #000;
`;

export const LBBtn = styled.button`
  position: absolute;
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  cursor: pointer;
  color: #fff;
  font-size: 20px;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.16);
  transition: all 0.2s ease;

  &:hover {
    background: ${(props) => props.theme.text};
    color: #050505;
    border-color: ${(props) => props.theme.text};
  }

  &.close {
    top: 26px;
    right: 26px;
  }
  &.prev {
    left: 26px;
    top: 50%;
    transform: translateY(-50%);
  }
  &.next {
    right: 26px;
    top: 50%;
    transform: translateY(-50%);
  }

  @media screen and (max-width: 768px) {
    width: 42px;
    height: 42px;
    &.prev { left: 10px; }
    &.next { right: 10px; }
    &.close { top: 14px; right: 14px; }
  }
`;

export const LBCount = styled.div`
  position: absolute;
  bottom: 26px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 14px;
  font-weight: 600;
  color: #c4ccd8;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.12);
  padding: 6px 14px;
  border-radius: 999px;
`;

export const CtaRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
`;

export const Section = styled.div`
  margin-bottom: 40px;
`;

export const Label = styled.h2`
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 2px;
  text-transform: uppercase;
  color: ${(props) => props.theme.text};
  margin-bottom: 16px;
`;

export const Body = styled.p`
  font-size: 17px;
  line-height: 1.8;
  color: #b8c0cc;
`;

export const TechRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
`;

export const TechChip = styled.span`
  font-size: 13px;
  font-weight: 600;
  padding: 8px 14px;
  border-radius: 10px;
  color: #e9edf5;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
`;

export const Cta = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 14px 30px;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 700;
  color: #050505;
  background: ${(props) => props.theme.text};
  text-decoration: none;
  box-shadow: 0 14px 36px -14px ${(props) => props.theme.text};
  transition: transform 0.2s ease;

  &:hover {
    transform: translateY(-2px);
  }
`;

export const Nav = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 16px;
  margin-top: 60px;
  padding-top: 30px;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
`;

export const NavLink = styled(Link)`
  display: flex;
  flex-direction: column;
  text-decoration: none;
  color: #8b94a3;
  font-size: 14px;
  transition: color 0.2s ease;
  max-width: 45%;

  &.next {
    text-align: right;
    align-items: flex-end;
  }
  strong {
    font-size: 17px;
    color: #fff;
    margin-top: 4px;
  }
  &:hover {
    color: ${(props) => props.theme.text};
  }
  &:hover strong {
    color: ${(props) => props.theme.text};
  }
`;

export const NotFound = styled.div`
  text-align: center;
  padding: 60px 0;

  h1 {
    font-size: 32px;
    margin-bottom: 16px;
  }
`;
